module.exports = __webpack_public_path__ + "img/mansard.9f7e5bdc.jpg";